﻿<template>
    <div class="summary-price section sm-prices" :hidden="get_Trip_Total() == get_Total()">
        <div class="sm-price-box">
            <div class="sm-row">
                <span>Trip price</span>
                <span>{{get_Trip_Total()}}</span>
            </div>
            <div v-if="is_Discounted()" class="sm-row is-discount">
                <span>
                    Discount
                    <span v-if="show_percentage">{{get_Discount_Percentage()}}</span>
                </span>
                <span>{{get_Discount()}}</span>
            </div>
            <div v-if="is_Discounted() && hasAddOns" class="sm-row">
                <span>Tour subtotal</span>
                <span>{{get_Full_Total()}}</span>
            </div>
            <div v-if="hasAddOns" class="sm-row is-divided">
                <span>{{get_AddOnText()}}</span>
                <span>{{get_AddOn_Total()}}</span>
            </div>
        </div>
        <div v-if="show_total" class="sm-row is-total">
            <span>Total</span>
            <span>{{get_Total()}}</span>
        </div>
    </div>
</template>

<script lang="ts" src="./trip_summary.ts"></script>